(function ($) {
    $.fn.flashClass = function(className, valueChange = true) {
        var field = $(this);
        field.removeClass('flash off green red');
        
        // Only flash the field if the value has changed
        if (!valueChange || (valueChange && field.val() != field.data('old-value'))) {
            field.addClass('flash ' + className);
        }

        // Remember the old value
        field.data('old-value', field.val());

        setTimeout(function() {
            field.addClass('off');
        }, 50);

        return this;
    };
}(jQuery));
